const CloseLogo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 268 267">
            <path
                d="M260.796 260.524c-5.344 8.628-19.079 8.628-24.868 0L133.412 158.2 31.01 260.524c-8.053 8.628-19.337 8.628-24.83 0-8.277-8.237-8.277-18.901 0-24.095l103.143-103.236L6.18 31.014c-8.277-8.237-8.277-18.996 0-24.802 5.493-8.312 16.777-8.312 24.83 0l102.402 102.735L235.928 6.212c5.789-8.312 19.524-8.312 24.868 0 7.795 5.806 7.795 16.565 0 24.802L158.729 133.193l102.067 103.236c7.795 5.194 7.795 15.858 0 24.095z"
                fillRule="evenodd"
            />
        </svg>
    );
};

export default CloseLogo;
